"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var CmsBotsList_1 = require("./component/CmsBotsList");
var CmsBotEditor_1 = require("./component/CmsBotEditor");
var PCmsBotsList = /** @class */ (function (_super) {
    __extends(PCmsBotsList, _super);
    function PCmsBotsList(props) {
        return _super.call(this, props) || this;
    }
    PCmsBotsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.dataBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_GP = this.props.dataGameProviders.Subscribe("*", function (id, data) {
            _this.setState({ avail_game_providers: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            record: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_game_providers: []
        }, function () {
            _this.props.dataBrands.LoadData();
            _this.props.dataGameProviders.LoadData();
        });
    };
    PCmsBotsList.prototype.componentWillUnmount = function () {
        this.props.dataBrands.UnSubscribe(this.SID_AB);
        this.props.dataGameProviders.UnSubscribe(this.SID_GP);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PCmsBotsList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", record: null });
    };
    PCmsBotsList.prototype.onEditClick = function (val) {
        this.setState({ edit_mode: "EDIT", record: val });
    };
    PCmsBotsList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", record: null });
    };
    PCmsBotsList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PCmsBotsList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PCmsBotsList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(CmsBotEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, dataUsrPlayers: this.props.dataUsrPlayers, dataGameProviderGames: this.props.dataGameProviderGames, gwsGameProvidersAvail: this.state.avail_game_providers, dataGameSets: this.props.dataGameSets }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(CmsBotEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.record, onGoBack: this.onGoBackClick.bind(this), brandsAvail: this.state.avail_brands, dataUsrPlayers: this.props.dataUsrPlayers, dataGameProviderGames: this.props.dataGameProviderGames, gwsGameProvidersAvail: this.state.avail_game_providers, dataGameSets: this.props.dataGameSets }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(CmsBotsList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PCmsBotsList.prototype.render = function () {
        return this.getRenderObject();
    };
    PCmsBotsList.getPageDescription = function (state) {
        return {
            icon: "robot",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_cms_bots_list + "-id",
            itemTitle: "Боты",
            route: routes_1.routes.page_cms_bots_list,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PCmsBotsList;
}(React.Component));
exports.default = PCmsBotsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_bots/ui/PCmsBotsList.tsx
// module id = 2332
// module chunks = 0